export default {"src":"/_next/static/media/green-circle-with-heart.666ca71f.svg","height":113,"width":176,"blurWidth":0,"blurHeight":0};